import grapesjs from 'grapesjs';
import loadComponents from './components';
import loadBlocks from './blocks';

export default grapesjs.plugins.add('display-playlist-plugin', (editor, opts = {}) => {
  // Add components
  loadComponents(editor, opts);

  //  // Add blocks
  loadBlocks(editor, opts);
});



// WEBPACK FOOTER //
// ./src/plugins/playlist/index.js